var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearchWebsite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M15.5 15.5l-4.715-4.714M6.5 12.5a6 6 0 100-12 6 6 0 000 12z",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}
export default SvgIconSearchWebsite;